import { render, staticRenderFns } from "./SurveyResponses.vue?vue&type=template&id=52f86cbe&"
import script from "./SurveyResponses.vue?vue&type=script&lang=js&"
export * from "./SurveyResponses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports